import { styled } from '@uhg-abyss/web/tools/styled';

export const Styles = styled('div', {
  '#filtersContainer': {
    marginTop: 'calc(calc(var(--abyss-space-xl) + var(--abyss-space-sm)) * -1)',
  },
  '#viewsContainer': {
    '.abyss-flex-root': {
      '.abyss-select-input-multi-root': {
        position: 'relative',
      },
      '> div:first-of-type': {
        paddingRight: 'var(--abyss-space-md)',
        width: 'calc(100%  - 90px)',
      },
    },
    borderBottom: '1px solid var(--abyss-colors-gray4)',
    borderLeft: '1px solid var(--abyss-colors-gray4)',
    borderRight: '1px solid var(--abyss-colors-gray4)',
  },
});
